/**
 * Checks if the given hostname is considered an HEI domain.
 * Currently, 'hei.sklls.ai' and 'localhost' are considered HEI domains
 * for development and production purposes.
 *
 * @param hostname The hostname to check (e.g., window.location.hostname).
 * @returns True if the hostname is an HEI domain, false otherwise.
 */
export const isHeiDomain = (hostname: string): boolean => {
  if (typeof hostname !== 'string') {
    return false;
  }
  // return hostname === 'hei.sklls.ai' || hostname === 'localhost'; // use this for local development, debuging hei.sklls.ai handling
  return hostname === 'hei.sklls.ai';
};
